import { Box } from '@mui/material'
import { Icon } from 'packages/eid-icons'

const InfoBoxWithIcon = ({
    message,
    iconName,
    iconStyles = {},
    messageStyles = {},
    iconAreaStyles = {},
    rootStyles = {},
}) => {
    return (
        <Box
            sx={{
                border: 'solid 1px #ebebed',
                boxShadow: ' 0 0.4rem 0.6rem -0.2rem rgba(0, 0, 0, 0.1)',
                borderRadius: '0.5rem',
                display: 'inline-flex',
                alignItems: 'center',
                minHeight: '4.8rem',
                background: '#fff',
                overflow: 'hidden',
                ...rootStyles,
            }}
        >
            <Box
                sx={{
                    background: '#8b909a',
                    width: '4.8rem',
                    padding: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '100%',
                    alignSelf: 'stretch',
                    ...iconAreaStyles,

                    '& svg': {
                        width: '2.4rem !important',
                        height: '2.4rem !important',
                        color: 'white',
                        ...iconStyles,
                        '& path': {
                            fill: iconStyles?.color || '#fff',
                        },
                    },
                }}
            >
                <Icon name={iconName} />
            </Box>
            <Box
                sx={{
                    padding: '1.6rem',
                    color: '#5d6870',
                    ...messageStyles,
                }}
            >
                {message}
            </Box>
        </Box>
    )
}

export default InfoBoxWithIcon
